import styled from "styled-components";

export const LeftAlignTabs = styled.div`
  div[class^="Tabsstyle__TabList-sc"] {
    justify-content: left;
  }
`;

export const RightAlignContent = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  z-index: 1; /* Makes the text on the colour keys selectable */
  margin-top: 30px; /* Half of the table's height */
`;
